// libs
import { styled } from '@nykaa/ui-components';

// mixins
import { truncate } from 'shared/styles/mixin';

//components
import ChevronDownSmall from '@nykaa/ui-components/Icons/chevron-down-small';

export const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  padding: ${({ theme }) =>
    `${theme.spacing.spacing60} ${theme.spacing.spacing50} ${theme.spacing.spacing60} 0`};

  &:hover {
    color: ${({ theme }) => theme.colors.secondary};
  }
`;

export const Title = styled.div<{ isCollapsedView: boolean }>`
  ${({ theme }) => theme.typography.bodyMedium};
  ${({ isCollapsedView, theme }) => !isCollapsedView && theme.typography.subTitleMedium};
  ${truncate};
`;

export const UpArrow = styled(ChevronDownSmall)`
  transform: rotate(180deg);
`;

export const RightArrow = styled(ChevronDownSmall)`
  transform: rotate(270deg);
`;

export const Count = styled.div`
  ${({ theme }) => theme.typography.subTitleMedium};
  color: ${({ theme }) => theme.colors.secondary};
  margin-right: ${({ theme }) => theme.spacing.spacing60};
`;

export const Wrapper = styled.div`
  display: flex;
`;
